<template>
  <!-- 异常原文合并弹窗 -->
  <div class="srcMerge">
    <el-dialog
      width="75%"
      title="异常原文合并"
      :visible="visible"
      :close-on-click-modal="false"
      @close="closeDialog"
      center
    >
      <div class="m-b-5 f-w-600">确定操作合并如下原译文？</div>
      <el-table
        class="f-s-14 m-b-15"
        style="width: 100%"
        max-height="150"
        border
        :data="sentList"
        :row-class-name="getGrey"
      >
        <el-table-column
          prop="id"
          label="句子ID"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column prop="srcText" label="原文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.srcText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="mtText" label="机翻译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.mtText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="peTextShow" label="译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.peTextShow" readonly />
          </template>
        </el-table-column>
      </el-table>
      <div class="m-b-5 f-w-600">合并后效果预览</div>
      <el-table
        class="f-s-14 m-b-15"
        style="width: 100%"
        max-height="150"
        border
        :data="previewData"
        :row-class-name="getGrey"
      >
        <el-table-column
          prop="id"
          label="句子ID"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column prop="srcText" label="原文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.srcText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="mtText" label="机翻译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.mtText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="peTextShow" label="译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.peTextShow" readonly />
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mergeConfirm">确定合并</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mergeSent } from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import RichText, { jsonTextToText } from '@/components/rich-text';

export default {
  name: 'SrcMergeDialog',
  props: [
    'visible',
    'staParams', // 上报公共参数
    'sentData',
    'qcTaskId',
    'slan',
    'tlan',
  ],
  components: {
    RichText,
  },
  data() {
    return {
      sentList: [],
      previewData: [],
    };
  },
  watch: {
    visible(val) {
      // 弹窗每次出现都重新合并
      if (val) {
        this.sentList = this.sentData;
        this.previewData = [];
        const index = this.sentData.length - 1;
        const srcText = this.sentData.map((item) => {
          if (this.slan === 'zh-CN') {
            return JSON.parse(item.srcText);
          } else {
            return [...JSON.parse(item.srcText), { insert: ' ' }];
          }
        });
        const src = [].concat.apply([], srcText);
        const mtText = this.sentData.map((item) => {
          if (this.tlan === 'zh-CN') {
            return JSON.parse(item.mtText);
          } else {
            return [...JSON.parse(item.mtText), { insert: ' ' }];
          }
        });
        const mt = [].concat.apply([], mtText);
        const peTextShow = this.sentData.map((item) => {
          if (this.tlan === 'zh-CN') {
            return JSON.parse(item.peTextShow);
          } else {
            return [...JSON.parse(item.peTextShow), { insert: ' ' }];
          }
        });
        const pe = [].concat.apply([], peTextShow);
        const params = {
          id: this.sentData[index].id,
          srcText: JSON.stringify(src),
          mtText: JSON.stringify(mt),
          peTextShow: JSON.stringify(pe),
        };
        this.previewData.push(params);
      } else {
        this.sentList = [];
        this.previewData = [];
      }
    },
  },
  methods: {
    // 句子合并
    mergeConfirm() {
      const sentIds = this.sentData.map((item) => {
        return item.id;
      });
      mergeSent({
        qcTaskId: this.qcTaskId,
        sentIds: sentIds,
        mtText: this.previewData[0].mtText,
        srcText: this.previewData[0].srcText,
        peText: this.previewData[0].peTextShow,
      }).then((res) => {
        this.sentData = [];
        this.previewData = [];
        this.$message.success('操作成功');
        this.closeDialog();
        this.$emit('sent-merge');
      });
      statistics(
        Object.assign(
          {
            event_name: '异常原文合并',
            event_type: 'click',
            class_name: 'mergeSent',
            qcTermList: '/dotadmin/dotadmin/merge/mergeSent',
            event_params: '{orderId:pageQuery.orderId}',
          },
          this.staParams,
        ),
      );
    },

    // 关闭弹窗回调
    closeDialog() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
